<template lang="pug">
div#main
    div.background.fullfill
        div.overlay.fullfill
        video.background-video(
            v-if="pageInfo.background && pageInfo.background.video && showVideo" ref="backgroundVideo" 
            autoplay loop :muted="true" plays-inline
            :style="videoCss"
        )
            source(:src="pageInfo.background.video" type="video/mp4")
        div.background-image(
            v-if="pageInfo.background && pageInfo.background.image && !showVideo" 
            :style="'background-image: url(' + pageInfo.background.image + getOptimalImageSize('crop', 'fullwidth', null) + ')'"
        )
    div.content.fullfill.table
        div.table-cell
            div.container
                h1.head(v-if="pageInfo.phrase") {{ pageInfo.phrase[$i18n.locale] }}
        div.showreel-link(v-if="pageInfo.showreel")
            a.grey.action(@click="$refs.modal.open()") {{ $t('$buttons.showreel') }}
    modal.video-modal(@opened="pauseBackgroundVideo" @closed="playBackgroundVideo" ref="modal")
        video-block(v-if="pageInfo.showreel" :content="pageInfo.showreel" ref="showreelVideo")
</template>

<script>
import Page from './templates/Page.vue'
import Modal from '../components/modals/Modal.vue'
import VideoBlock from '../components/blocks/VideoBlock.vue'
export default {
    name: 'main-page',
    extends: Page,
    metaInfo() {
        var title = "Sota. " + this.$t('$meta.main.title') + ".";
        var description = this.pageInfo.phrase ? this.pageInfo.phrase[this.$i18n.locale] : "";
        return {
            title: title,
            titleTemplate: null,
            meta: [
                { property: "og:title", content: title },
                { property: "og:description", content: description },
                { property: "og:video", content: this.pageInfo.showreel },
                { property: "og:url", content: this.$router.fullPath },
                { name: "twitter:title", content: title },
                { name: "twitter:description", content: description }
            ]
        }
    },
    data() {
        return {
            showVideo: window.innerWidth > 768,
            pageInfo: {},
            video: {
                width: null,
                height: null,
                left: null,
                top: null
            }
        }
    },
    created() {
        if (window.innerWidth <= 768) { this.showVideo = false }
        this.resizeVideo();
        window.onresize = this.resizeVideo;
        this.$emit("init", "white", false);
        this.$http.get("pages/main").then(response => {
            this.pageInfo = response.body;
            this.$emit("end-loading");
        })
    },
    computed: {
        videoCss() {
            var style = ""
            if (this.video.width)
                style += "width: " + this.video.width + "px;"
            if (this.video.height)
                style += "height: " + this.video.height + "px;"
            if (this.video.left)
                style += "left: " + this.video.left + "px;"
            if (this.video.top)
                style += "top: " + this.video.top + "px;"
            return style
        }
    },
    destroyed() {
        window.onresize = null;
    },
    methods: {
        resizeVideo() {
            console.log("resize")
            this.video = {}
            if(window.innerWidth / window.innerHeight > 16/9) {
                this.video.width = window.innerWidth
                this.video.top = - (this.video.width / 16 * 9 - window.innerHeight) / 2
            } else {
                this.video.height = window.innerHeight
                this.video.left = - (this.video.height / 9 * 16 - window.innerWidth) / 2
            }
        },
        playBackgroundVideo: function() {
            this.$refs.backgroundVideo.play();
            this.$refs.showreelVideo.pause();
        },
        pauseBackgroundVideo: function() {
            this.$refs.backgroundVideo.pause();
            this.$refs.showreelVideo.play();
        }
    },
    components: {
        'modal': Modal,
        'video-block': VideoBlock
    }
}
</script>

<style lang="scss">
@import '~styles/mixins.scss';
#main {
    position: static;
    .background {
        background-color: black;
    }
    .video-modal {
        padding-top: 70px;
        .container {
            max-width: 1040px;
            @media (max-width: grid-breakpoint(sm)) {
                padding: 0;
            }
        }
    }
    .content {
        .container {
            margin-top: -15px;
            max-width: 1100px;
            @media (min-width: grid-breakpoint(lg)) {
                padding-left: 25px;
                padding-right: 25px;
            }
        }
        h1 {
            margin: 0;
            color: #ffffff;
            @media (max-width: grid-breakpoint(md)) {
                font-size: 60px;
                line-height: 0.90;
                letter-spacing: -1.2px;
            }
            @media (max-width: grid-breakpoint(sm)), (max-height: 450px) {
                font-size: 45px;
                line-height: 0.89;
                letter-spacing: -0.9px;
            }
        }
        .showreel-link {
            position: absolute;
            bottom: 100px;
            left: 0;
            right: 0;
            .action {
                color: white;
            }
            @media (max-height: 450px) {
                bottom: 40px;
            }
        }
    }
    .background {
        position: fixed;
        .overlay {
            z-index: 3;
            background: black;
            opacity: 0.4;
        }
        .background-video {
            z-index: 2;
            min-width: 100%;
            min-height: 100%;
            position: absolute;
        }
        .background-image {
            z-index: 1;
            min-width: 100%;
            min-height: 100%;
            position: relative;
            background-size: cover;
            background-position: center center;
        }
    }
}
</style>



// WEBPACK FOOTER //
// Main.vue?c7cec1cc